import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import get from 'lodash/get'

const styles = {
    link: {
        color: '#3f51b5',
        textDecoration: 'none',
        
    },
    linkContent : {
        color: '#3f51b5',
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: '1.46429em'
    }
}


const stopPropagation = e => e.stopPropagation();

const ReferenceLinkField = ({ source, sourceFields, reference, record = {}, classes }) => {

    const referenceBasepath = reference || get(record, sourceFields.reference)
    if(!referenceBasepath){
        return null
    }

    return (
    <Link 
        className={classes.link}
        to={`/${referenceBasepath}/${get(record, sourceFields.id)}`}
        onClick={stopPropagation}
    >
        <Typography className={classes.linkContent} >
            {get(record, sourceFields.name)}
        </Typography>
    </Link> 
)
}

ReferenceLinkField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string,
    sourceFields: PropTypes.object.isRequired,
    reference: PropTypes.string,
};

export default withStyles(styles)(ReferenceLinkField)